module.exports = __webpack_public_path__ + "media/images/dashboard/prescription_portrait-f952cb3c6b52c69b2907d9f180f3e6c9ab21b27351b313a4cd3b097d0737477e.png";